import { useEffect, useState } from 'react'
import { getClinicsDetailed } from '../api'
import { clinics as mockClinics } from '../constants/mockClinics'
import { mapToOptions } from '../utils/mapToOptions'
import to from 'await-catch'

let inFlightClinicsRequest = null

export function useClinicsOptions({
  showLoader,
  hideLoader,
  addFlashMessage,
  useMockFallback = true
}) {
  const [clinicsOptions, setClinicOptions] = useState([])
  const [clinics, setClinics] = useState([])

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      try {
        showLoader && showLoader()

        if (!inFlightClinicsRequest) {
          inFlightClinicsRequest = to([getClinicsDetailed()]).finally(() => {
            inFlightClinicsRequest = null
          })
        }

        const [err, [{ data: clinicsData } = {}]] = await inFlightClinicsRequest
        if (err || !Array.isArray(clinicsData) || clinicsData.length === 0) {
          throw new Error('Error en el fetch de clínicas o respuesta vacía')
        }
        if (!isMounted) return

        setClinicOptions(mapToOptions(clinicsData, 'id', 'nombre'))
        setClinics(clinicsData)
      } catch (error) {
        if (!isMounted) return

        if (useMockFallback) {
          setClinicOptions(mapToOptions(mockClinics, 'id', 'nombre'))
          setClinics(mockClinics)
          addFlashMessage &&
            addFlashMessage('Ocurrió un error cargando las clínicas, se muestran datos por defecto')
          return
        }

        setClinicOptions([])
        setClinics([])
        addFlashMessage && addFlashMessage('Ocurrió un error cargando las clínicas')
      } finally {
        if (!isMounted) return
        hideLoader && hideLoader()
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [showLoader, hideLoader, addFlashMessage, useMockFallback])

  return { clinicsOptions, clinics }
}
